import axios from 'axios';
import qs from 'qs';
import { createInfiniteQuery } from 'react-query-kit';

import { HTTP_HEADERS } from '@/constants';
import { filterEmptyParams, restUrl } from '@/services/utils';

import { ItemDataType } from './itemsList.types';

interface ItemsVariables {
    [key: string]: string;
}

interface ItemDataResponse {
    data: ItemDataType[];
    cursor?: string;
    itemsFound?: string;
    itemsMax?: string;
}

const useItemsData = createInfiniteQuery<ItemDataResponse, ItemsVariables, Error, string | undefined>({
    queryKey: ['items'],
    fetcher: async (variables, { pageParam }) => {
        const response = await axios.get(restUrl('items'), {
            params: variables,
            headers: {
                [HTTP_HEADERS.X_ITEM_CURSOR]: pageParam
            },
            paramsSerializer: (params) => {
                // Array-valued params (sort, direction, fields, ...) must be
                // serialised as repeated keys so JAX-RS binds them to
                // `List<String>` @QueryParam handlers. This matches what
                // AngularJS `$resource` sent for the legacy grid (LAX-10036).
                return qs.stringify(filterEmptyParams(params), { arrayFormat: 'repeat' });
            }
        });

        return {
            data: response.data ?? [],
            cursor: response.headers[HTTP_HEADERS.X_ITEM_CURSOR] ?? undefined,
            itemsFound: response.headers[HTTP_HEADERS.X_ITEMS_FOUND] ?? undefined,
            itemsMax: response.headers[HTTP_HEADERS.X_ITEMS_MAX] ?? undefined
        };
    },
    getNextPageParam: (lastPageRequestResponse) => lastPageRequestResponse.cursor,
    initialPageParam: undefined
});

export default useItemsData ;
